<template>
  <button class="mcr-button" :class="{disabled: disabled}" :disabled="disabled" @click="click" tabindex="0">
    <div v-if="!loading" class="mcr-button-label">
      <slot>{{ label }}</slot>
    </div>

    <template v-if="loading">
      <spinner-loading v-if="loadingSpinner"></spinner-loading>
      <bounce-loading v-else></bounce-loading>
    </template>
  </button>
</template>

<script>
import SpinnerLoading from '@common/elements/loading-indicators/SpinnerLoading';
import BounceLoading from '@common/elements/loading-indicators/bounceLoading';

export default {
  props: {
    loading: Boolean,
    loadingSpinner: {type: Boolean, default: false},
    label: String,
    disabled: {type: Boolean, default: false},
    href: {type: String, optional: true},
  },
  methods: {
    click() {
      if (!this.disabled && !this.loading) {
        if (this.href) {
          const w = window.open(this.href, '_blank');
          if (w) w.focus();
        }
        this.$emit('click');
      }
    },
  },
  components: {SpinnerLoading, BounceLoading},
};
</script>

<style lang="scss" scoped>
@use '@common/style/mcr-button';
</style>
